import React, { useState } from "react";
import Login from "../components/Login";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "../styles/login.css"

function AiInterviewLogin({config}) {
  const [whiteLabelingObject,setWhiteLabelingObject] = useState()
  return (
    <>
      {/* <div className=" min-h-screen  bg-primaryBg"> */}
      <div className="login-landing-page min-h-screen bg-primaryBg text-primaryWhite px-5 lg:px-8 py-2 flex flex-col justify-between items-center">
        <Navbar config={whiteLabelingObject} />
        <Login setWhiteLabelingObject={setWhiteLabelingObject} />
        <Footer />
      </div>
      {/* </div> */}
    </>
  );
}

export default AiInterviewLogin;
